import { MaskedLines, FadeIn } from "@/components/motion";

export default function PageHeader({ eyebrow, lines, intro, testid }) {
  return (
    <section className="relative overflow-hidden px-6 pb-16 pt-20 lg:px-10 lg:pb-24 lg:pt-28">
      <div className="mx-auto max-w-7xl">
        <FadeIn>
          <p className="text-sm font-bold uppercase tracking-[0.25em] text-teal">{eyebrow}</p>
        </FadeIn>
        <h1
          data-testid={testid}
          className="mt-6 font-serif text-5xl font-medium leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-7xl"
        >
          <MaskedLines lines={lines} delay={0.1} />
        </h1>
        {intro && (
          <FadeIn delay={0.45}>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-olive/75">{intro}</p>
          </FadeIn>
        )}
      </div>
    </section>
  );
}
